export default ".margin-botm{margin-bottom:20px !important}.button-container{margin-top:10px}.margin-left{margin-left:6px !important}";